import { Shield, ShieldProps } from 'shield-js-npm'

interface DeviceIntelligenceResponse {
  result: {
    // eslint-disable-next-line camelcase
    session_id: string;
  }
}

export const getShieldSessionId = async () => {
  const shield = new Shield()
  const props: ShieldProps = {
    siteId: process.env.SHIELD_SITE_ID!,
    url: `${process.env.BASE_URL}/server-middleware`
  }

  try {
    await shield.init(props)
    const res = await shield.getDeviceIntelligence() as DeviceIntelligenceResponse

    return res.result.session_id
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error getting shield session id: ', error)
    return null
  }
}
